export const StopRels = {
    getStops: 'getStops'
};
